// Typelizer digest ce9d6e84d36c0ed29172c2037e5c043d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /api/invitations/:project_id */
  create: (
    params: { projectId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/api/invitations/:project_id', params, options),
    method: 'post',
  }),
}
